interface Props {
  label: string;
  loading?: boolean;
  updating?: boolean;
  error?: string | null;
  onRetry: () => void;
}

/** Keep controls and successfully loaded panels usable when one request fails. */
export default function DashboardQueryStatus({
  label,
  loading,
  updating,
  error,
  onRetry,
}: Props) {
  if (error) {
    return (
      <div
        role="alert"
        className="rounded-lg border border-destructive/50 bg-destructive/10 px-4 py-3 text-sm text-destructive"
      >
        Could not load {label}. Any previously loaded results may be out of
        date.{" "}
        <button
          type="button"
          onClick={onRetry}
          disabled={loading || updating}
          className="underline disabled:opacity-50"
        >
          {loading || updating ? "Retrying…" : "Retry"}
        </button>
      </div>
    );
  }
  if (loading) {
    return (
      <div
        role="status"
        aria-label={`Loading ${label}`}
        className="space-y-3 py-3"
      >
        <p className="text-sm text-muted-foreground">Loading {label}…</p>
        <div className="h-24 animate-pulse rounded-lg bg-muted" />
      </div>
    );
  }
  if (updating)
    return (
      <p role="status" className="text-sm text-muted-foreground">
        Updating {label}… Previous results are still shown.
      </p>
    );
  return null;
}
